import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Box,
  HStack,
} from "@chakra-ui/react";
import { AddStartgroupModalProps, Startgroup } from "../api/Dtos";
import { OfiDateTimeRangePicker } from "../HelperComponents/DateTimePickers";
import { useGlobalContext } from "../Layout/GlobalState";

const AddStartgroupModal: React.FC<AddStartgroupModalProps> = ({
  isOpen,
  onClose,
  onAddRow,
}) => {
  const globalContext = useGlobalContext();

  const [startTimePlannedInMs, setStartTimePlannedInMs] = useState<
    null | number
  >(null);
  const [endTimePlannedInMs, setEndTimePlannedInMs] = useState<null | number>(
    null
  );
  const [startTimeActualInMs, setStartTimeActualInMs] = useState<null | number>(
    null
  );
  const [endTimeActualInMs, setEndTimeActualInMs] = useState<null | number>(
    null
  );

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    //console.info('id: ' + id + ', starttime_planned: ' + starttime_planned );
    if (startTimePlannedInMs && endTimePlannedInMs) {
      onAddRow({
        id: 0,
        starttime_planned: startTimePlannedInMs,
        starttime_actual: startTimeActualInMs,
        closetime_planned: endTimePlannedInMs,
        closetime_actual: endTimeActualInMs,
      });
    }
    setStartTimePlannedInMs(null);
    setEndTimePlannedInMs(null);
    setStartTimeActualInMs(null);
    setEndTimeActualInMs(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Lägg till Startgrupp</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <HStack spacing={10}>
            <Box
              borderRadius={"10px"}
              background={"blue.200"}
              padding={"40px"}
              shadow={"2xl"}
            >
              <Text fontSize={"24px"}>Plannerade tider</Text>
              <OfiDateTimeRangePicker
                start={
                  startTimePlannedInMs == null
                    ? null
                    : new Date(startTimePlannedInMs)
                }
                end={
                  endTimePlannedInMs == null
                    ? null
                    : new Date(endTimePlannedInMs)
                }
                setStart={(date) => {
                  setStartTimePlannedInMs(date?.getTime() || null);
                }}
                setEnd={(date) => {
                  setEndTimePlannedInMs(date?.getTime() || null);
                }}
                earliestPossibleDate={
                  globalContext.competition?.startTime != null
                    ? new Date(globalContext.competition.startTime)
                    : undefined
                }
                lastPossibleDate={
                  globalContext.competition?.endTime != null
                    ? new Date(globalContext.competition.endTime)
                    : undefined
                }
              />
            </Box>
            <Box
              borderRadius={"10px"}
              background={"gray.200"}
              padding={"40px"}
              shadow={"2xl"}
            >
              <Text fontSize={"24px"}>Faktiska tider</Text>
              <OfiDateTimeRangePicker
                start={
                  startTimeActualInMs == null
                    ? null
                    : new Date(startTimeActualInMs)
                }
                end={
                  endTimeActualInMs == null ? null : new Date(endTimeActualInMs)
                }
                setStart={(date) => {
                  setStartTimeActualInMs(date?.getTime() || null);
                }}
                setEnd={(date) => {
                  setEndTimeActualInMs(date?.getTime() || null);
                }}
              />
            </Box>
          </HStack>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isDisabled={
              startTimePlannedInMs == null || endTimePlannedInMs == null
            }
          >
            Lägg till Startgrupp
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Avbryt
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddStartgroupModal;
